module.exports = __webpack_public_path__ + "img/stock2.001176d9.png";